import { useQuery } from "@tanstack/react-query";
import { ChevronRight, Wallet } from "lucide-react";
import { useDataProvider, useTranslate } from "ra-core";
import { Link } from "react-router";

import type { NevoraDataProvider } from "../datos/dataProvider";
import { agruparMisComisiones, euros, mesDe } from "../dominio/comisiones";
import { MisComisionesPage } from "../equipo/MisComisionesPage";

/**
 * Comisiones del mes en el Inicio de setters y consultores (40, Robert 23/10/2026): lo cobrado este
 * mes (su comisión), lo pagado y la estimada de lo aceptado este mes, con acceso a «Mis comisiones».
 * El objetivo mensual (lo pondrán Jan y Robert) irá aquí, con su barra.
 */
export const ComisionesDelMes = () => {
  const translate = useTranslate();
  const dataProvider = useDataProvider<NevoraDataProvider>();
  const { data } = useQuery({
    queryKey: ["nevora", "mis-comisiones"],
    queryFn: () => dataProvider.misComisiones(),
  });
  const { totalEstimada, totalCobrada, totalPagada } = agruparMisComisiones(
    data ?? [],
    mesDe(new Date()),
  );
  const t = (k: string) => translate(`nevora.panel_direccion.comisiones.${k}`);
  return (
    <Link
      to={MisComisionesPage.path}
      className="block rounded-lg border bg-card p-4 hover:bg-muted/40"
      data-testid="comisiones-del-mes"
    >
      <div className="flex items-center gap-2">
        <Wallet className="size-4 text-muted-foreground" aria-hidden />
        <h2 className="titulo-seccion flex-1">{t("titulo")}</h2>
        <ChevronRight className="size-4 text-muted-foreground" aria-hidden />
      </div>
      <dl className="mt-3 grid grid-cols-3 gap-2">
        {(
          [
            ["cobrada", totalCobrada],
            ["pagada", totalPagada],
            ["estimada", totalEstimada],
          ] as const
        ).map(([k, v]) => (
          <div key={k}>
            <dt className="text-xs text-muted-foreground">{t(k)}</dt>
            <dd className="text-lg font-semibold tabular-nums">{euros(v)}</dd>
          </div>
        ))}
      </dl>
    </Link>
  );
};
